import React, { useEffect, useState } from "react";
import ScreenManager from "./screens/ScreenManager";


const APP_NAME = "Bitcoin Clock"
const APP_VERSION = "3.4.0"

/*
 * DEPLOYMENT TEMPLATE NOTES:
 * 
 * When creating new microservices that use GitHub Container Registry (GHCR):
 * 
 * CRITICAL: Always add imagePullSecrets to your Kubernetes YAML deployment:
 * 
 *   spec:
 *     containers:
 *       - name: your-service
 *         image: ghcr.io/anopenidea/your-service:main
 *         imagePullPolicy: Always
 *     imagePullSecrets:        <-- THIS IS REQUIRED!
 *       - name: ghcr-creds     <-- Must match existing secret name
 * 
 * Without imagePullSecrets, you'll get "401 Unauthorized" errors when Kubernetes
 * tries to pull private images from GHCR, even though your CI/CD builds successfully.
 * 
 * This was the root cause of bitcoin-api deployment issues - bitcoin-price worked
 * because it had imagePullSecrets, but bitcoin-api initially didn't.
 * 
 * Reference working examples: bitcoin-price.yaml, bitcoin-api.yaml
 */

function getApiUrl() { 
  // Use local API for development/testing
  if (window.location.hostname === 'clock.test.local' || 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1') {
    return "http://bitcoin.api.test.local/v1/";
  }
  // Use production API for live site
  return "https://bitcoin.api.bitcoinagree.com/v1/";
}

function getStatsUrl() {
  // Use local API for development/testing
  if (window.location.hostname === 'clock.test.local' || 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1') {
    return "http://bitcoin.api.test.local/v1/stats";
  }
  // Use production API for live site
  return "https://bitcoin.api.bitcoinagree.com/v1/stats";
}

export default function App() {
  const [btcPrice, setBtcPrice] = useState(null);
  const [blockHeight, setBlockHeight] = useState(null);
  const [stats, setStats] = useState(null);
  const [prevBlockTime, setPrevBlockTime] = useState(null);
  const [nextBlockTime, setNextBlockTime] = useState(null);
  const [btc, setBtc] = useState(1);
  const [usd, setUsd] = useState(0);

  useEffect(() => {
    document.title = `${APP_NAME} ${APP_VERSION}`;
    
    const fetchPrice = () => {
      const apiUrl = getApiUrl();
      
      fetch(apiUrl)
        .then((res) => res.json())
        .then((data) => {
          setBtcPrice(data.usd);
          setBlockHeight(data.block_height);
          setPrevBlockTime(data.prev_block_time);
          setNextBlockTime(data.next_block_time);
          setUsd(1 * data.usd);
        })
        .catch((error) => {
          console.error("Error fetching Bitcoin price:", error);
        });
    };

    const fetchStats = () => {
      fetch(getStatsUrl())
        .then((res) => res.json())
        .then((data) => {
          setStats(data);
        })
        .catch((error) => {
          console.error("Error fetching Bitcoin stats:", error);
        });
    };

    // Fetch data immediately
    fetchPrice();
    fetchStats();

    // Set up interval to fetch data every 10 seconds
    const interval = setInterval(() => {
      fetchPrice();
      fetchStats();
    }, 10000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const handleBtcChange = (e) => {
    const value = e.target.value;
    setBtc(value);
    if (btcPrice !== null && value !== "") setUsd(parseFloat(value) * btcPrice);
    else setUsd("");
  };

  const handleUsdChange = (e) => {
    const value = e.target.value;
    setUsd(value);
    if (btcPrice !== null && value !== "") setBtc(parseFloat(value) / btcPrice);
    else setBtc("");
  };

  return (
    <ScreenManager 
      btcPrice={btcPrice} 
      blockHeight={blockHeight} 
      stats={stats}
      prevBlockTime={prevBlockTime}
      nextBlockTime={nextBlockTime}
    />
  );
}



// WEBPACK FOOTER //
// ./src/App.js